import { Model } from './model';

export class Tag extends Model {
  id: string;

  name: string;

  color: string;
}
